// load fontawesome during runtime
async function importFontAwesomeJavascript() {
  await import(/* webpackPreload: true */ '@fortawesome/fontawesome-free/js/fontawesome');
  await import(/* webpackPrefetch: true */ '@fortawesome/fontawesome-free/js/solid');
  await import(/* webpackPrefetch: true */ '@fortawesome/fontawesome-free/js/regular');
  await import(/* webpackPrefetch: true */ '@fortawesome/fontawesome-free/js/brands');
  await import(/* webpackPrefetch: true */ '@fortawesome/fontawesome-free/js/v4-shims');
}

async function importFontAwesomeCss() {
  await import(/* webpackPrefetch: true */ '@fortawesome/fontawesome-free/css/all.css');
}

export { importFontAwesomeCss, importFontAwesomeJavascript };
